const ContactHero = () => {
  return (
    <section className="relative bg-leather-dark pt-28 pb-12 sm:pt-40 sm:pb-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        {/* Title */}
        <h1 className="font-display text-3xl sm:text-5xl md:text-7xl font-black text-cream mb-6 sm:mb-8 uppercase leading-tight">
          Get In Touch
        </h1>
        <div className="w-16 sm:w-24 h-1 bg-orange-burnt mx-auto mb-8 sm:mb-12"></div>

        {/* Intro */}
        <p className="font-sans text-base sm:text-xl md:text-2xl text-cream/90 leading-relaxed max-w-3xl mx-auto">
          Ready to work together? Send us your music, pitch, or inquiry.
        </p>
      </div>
    </section>
  );
};

export default ContactHero;
